import get from "lodash.get";
import { DonationType } from "../../../constants/donationType";
import { salutationTypes } from "../../../constants/salutation";
import { DeviceHelper } from "../../../helpers/deviceHelper";
import {
  getAddressModelFromFormbuilderAnswers,
  getCustomFields,
  getPhoneNumberFromFormbuilderAnswers,
} from "../../../helpers/formBuilderHelper";
import { paths } from "../constants";
import { displayNameKeys } from "../../../constants/displayNameOptions";

export const DONATION_VIA_WALLET_RECAPTCHA_KEY = "DonationViaWallet";

export const DONATE_KEY = "donate";
const FULL_NAME_KEY = "FullName";

export const WALLETS = new Map([
  ["googlePay", "Google Pay"],
  ["applePay", "Apple Pay"],
]);

export class StripePayment {
  private static getTemplateModel = () => {
    return {
      key: null,
      value: {},
    };
  };

  private static getDisplayName = (donation: any) => {
    const displayNameOption = get(donation, paths.SELECTED_DISPLAY_NAME_OPTION);
    return displayNameOption === displayNameKeys.asCustomName
      ? get(donation, paths.DISPLAY_NAME)
      : null;
  };

  private static getDisplayNameOption = (donation: any) => {
    const displayNameOption = get(donation, paths.SELECTED_DISPLAY_NAME_OPTION);
    return displayNameOption === displayNameKeys.asFullName ? FULL_NAME_KEY : null;
};

  static getDonation(donation: any, pageData: any, token: any) {
    return {
      template: this.getTemplateModel(),
      amount: donation.amount,
      message: donation.message,
      payment: {
        token: token.id,
        cardBrand: token.card.brand,
        cardCountry: token.card.country,
        cardExpiryMonth: token.card.exp_month,
        cardExpiryYear: token.card.exp_year,
        cardLast4Digits: token.card.last4,
        coverFee: donation.coverProcessingFee,
      },
      pageType: 1,
      fields: getCustomFields(donation.formbuilderAnswers),
      type: DonationType.Online,
      organizationId: get(pageData, "organization.id"),
      campaignId: get(pageData, "campaign.id"),
      displayName: this.getDisplayName(donation),
      displayNameOption: this.getDisplayNameOption(donation),
      device: {
        type: DeviceHelper.getDeviceType(),
        platform: DeviceHelper.getDevicePlatform(),
      },
      customer: {
        salutation:
          donation.customer.salutation !== salutationTypes.None
            ? donation.customer.salutation
            : null,
        email: donation.customer.email,
        firstName: donation.customer.firstName,
        lastName: donation.customer.lastName,
        anonymous: donation.customer.anonymous,
        businessName: donation.customer.isBehalfOfCompany
          ? donation.customer.businessName
          : null,
        newsletter: donation.customer.newsletter,
        phoneNumber: getPhoneNumberFromFormbuilderAnswers(
          donation.formbuilderAnswers
        ),
        address: getAddressModelFromFormbuilderAnswers(
          donation.formbuilderAnswers
        ),
      },
      issueReceipt: true,
    };
  }

  static getDonationForPaymentIntent = (donation: any, pageData: any) => {
    return {
      amount: donation.amount,
      campaignId: get(pageData, "campaign.id"),
      fields: getCustomFields(donation.formbuilderAnswers),
      collectionId: get(pageData, "collection.id"),
      donor: {
        salutation: donation.customer.salutation,
        email: donation.customer.email,
        firstName: donation.customer.firstName,
        lastName: donation.customer.lastName,
        anonymous: donation.customer.anonymous,
        businessName: donation.customer.isBehalfOfCompany
          ? donation.customer.businessName
          : null,
        newsletter: donation.customer.newsletter,
        phoneNumber: getPhoneNumberFromFormbuilderAnswers(
          donation.formbuilderAnswers
        ),
        address: getAddressModelFromFormbuilderAnswers(
          donation.formbuilderAnswers
        ),
      },
      device: {
        type: DeviceHelper.getDeviceType(),
        platform: DeviceHelper.getDevicePlatform(),
      },
      fundraiserId: get(pageData, "fundraiser.id"),
      displayName: this.getDisplayName(donation),
      displayNameOption: this.getDisplayNameOption(donation),
      message: donation.message,
      teamId: get(pageData, "team.id"),
      pageType: 1,
      coverFee: donation.coverProcessingFee,
      requiresPaymentIntent: true,
    };
  };
}
